import * as Sentry from '@sentry/react';
import { useInfiniteQuery, UseInfiniteQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  type DeviceType,
  type GetReleaseVersionsResponse,
  getReleaseVersions,
} from 'api/admin/firmware/firmware';

export const RELEASE_VERSIONS_PAGE_SIZE = 25;

const errorHandler = (error: unknown) => {
  Sentry.captureException(error);
};

export const useReleaseVersions = (
  deviceType?: DeviceType | null,
): UseInfiniteQueryResult<GetReleaseVersionsResponse, unknown> => {
  return useInfiniteQuery({
    queryKey: ['releaseVersions', deviceType ?? null],
    queryFn: async ({ pageParam = 1 }) => {
      const { data } = (await getReleaseVersions({
        deviceType: deviceType as DeviceType,
        page: pageParam,
        limit: RELEASE_VERSIONS_PAGE_SIZE,
      })) as AxiosResponse<GetReleaseVersionsResponse>;

      return data;
    },
    getNextPageParam: (lastPage) =>
      lastPage.currentPage < lastPage.totalPages ? lastPage.currentPage + 1 : undefined,
    enabled: Boolean(deviceType),
    onError: errorHandler,
    retry: 1,
  });
};
